<template>
  <el-upload
    class="avatar-uploader"
    action="#"
    :show-file-list="false"
    :on-change="onChange"
    :auto-upload="true"
    :http-request="upLoadFile"
    :before-upload="beforeAvatarUpload"
    accept="image/*"
  >
    <img v-if="imgUrl" :src="imgUrl" class="avatar" />
    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
  </el-upload>
</template>

<script>
export default {
  props: {
    imgUrl: {
      type: String,
      required: true
    },
    accept: {
      type: String,
      default: "image/*"
    }
  },
  data() {
    return {

    }
  },
  methods: {
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    // 改变文件
    onChange(file,fileList) {

    },
    upLoadFile(data) {
      let param = new FormData();
      param.append('file', data.file);
      this.$api.upLoadFile(param).then(res => {
        this.$emit('successUpload', res.data.data.urf);
      })
    }
  }
};
</script>
<style lang="less" scoped>
.avatar-uploader{
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .el-select{
  width: 100%;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
